import { call, put, takeLatest } from 'redux-saga/effects';
import { SMART_EDIT_STATUS_REQUEST, SMART_EDIT_TOP_CLAIM_REQUEST, SMART_EDIT_TOP_REASONS_REQUEST, SMART_EDITS_SUMMARY_REQUEST } from '@src/middleware/actions/actionTypes';
import { 
  fetchSmartEditsSummaryError, 
  fetchSmartEditsSummaryLoading, 
  fetchSmartEditsSummarySuccess, 
  fetchSmartEditStatusError, 
  fetchSmartEditStatusLoading, 
  fetchSmartEditStatusSuccess, 
  fetchSmartEditTopReasonsError, 
  fetchSmartEditTopReasonsLoading, 
  fetchSmartEditTopReasonsSuccess, 
  fetchSmartEditOverTimesError, 
  fetchSmartEditOverTimesLoading, 
  fetchSmartEditOverTimesSuccess,
  fetchSmartEditTopClaimError,
  fetchSmartEditTopClaimLoading,
  fetchSmartEditTopClaimSuccess
} from '@src/middleware/actions/ServiceInteraction/DigitalSolutions/smartEditsActions';
import { getSmartEditsSummaryDataRequest, getSmartEditsSummaryBulkRequest, getSmartEditStatusDataRequest, getSmartEditStatusBulkRequest, getSmartEditTopReasonsDataRequest, getSmartEditTopReasonsBulkRequest, getSmartEditOverTimesDataRequest, getSmartEditTopClaimDataRequest, getSmartEditOverTimesBulkRequest } from '@src/middleware/services/serviceInteraction/digitalSummary/smartEdits/smartEdits.service';
import { SMART_EDIT_OVER_TIMES_REQUEST } from '@src/middleware/actions/ServiceInteraction/DigitalSolutions/sm.ActionTypes';

export function* getSmartEditsSummaryData(action: any) {
  try {
    yield put(fetchSmartEditsSummaryLoading(true));

    const { showGeoSegView, isHighVolumeTinFlow, ...restPayload } = action?.payload || {};

    let response: any;

    if (isHighVolumeTinFlow) {
      // High Volume TIN Flow - Use parallel polling
      response = yield call(getSmartEditsSummaryBulkRequest, restPayload);
    } else {
      // Normal Flow or Geo Flow
      response = yield call(
        getSmartEditsSummaryDataRequest,
        restPayload,
        showGeoSegView
      );
    }

    yield put(fetchSmartEditsSummarySuccess(response));
    yield put(fetchSmartEditsSummaryLoading(false));
  } catch (error) {
    yield put(fetchSmartEditsSummaryError(true));
    yield put(fetchSmartEditsSummaryLoading(false));
  }
}

export function* getSmartEditStatusData(action: any) {
  try {
    yield put(fetchSmartEditStatusLoading(true));

    const { showGeoSegView, isHighVolumeTinFlow, ...restPayload } = action?.payload || {};
    
    let response: any;

    if (isHighVolumeTinFlow) {
      // High Volume TIN Flow - Use parallel polling
      response = yield call(getSmartEditStatusBulkRequest, restPayload);
    } else {
      // Normal Flow or Geo Flow
      response = yield call(
        getSmartEditStatusDataRequest,
        restPayload,
        showGeoSegView
      );
    }
    
    yield put(fetchSmartEditStatusSuccess(response));
    yield put(fetchSmartEditStatusLoading(false));
  } catch (error) {
    yield put(fetchSmartEditStatusError(true));
    yield put(fetchSmartEditStatusLoading(false));
  }
}

export function* getSmartEditTopReasonsData(action: any) {
  try {
    yield put(fetchSmartEditTopReasonsLoading(true));

    const { showGeoSegView, isHighVolumeTinFlow, ...restPayload } = action?.payload || {};

    let response: any;

    if (isHighVolumeTinFlow) {
      // High Volume TIN Flow - Use parallel polling
      response = yield call(getSmartEditTopReasonsBulkRequest, restPayload);
    } else {
      // Normal Flow or Geo Flow
      response = yield call(
        getSmartEditTopReasonsDataRequest,
        restPayload,
        showGeoSegView
      );
    }

    yield put(fetchSmartEditTopReasonsSuccess(response));
    yield put(fetchSmartEditTopReasonsLoading(false));
  } catch (error) {
    yield put(fetchSmartEditTopReasonsError(true));
    yield put(fetchSmartEditTopReasonsLoading(false));
  }
}

export function* getSmartEditOverTimesData(action: any) {
  try {
    yield put(fetchSmartEditOverTimesLoading(true));

    const actionType = action?.payload?.type || 'LOB';
    const { type, showGeoSegView, isHighVolumeTinFlow, ...restPayload } = action?.payload || {};

    let response: any;

    if (isHighVolumeTinFlow) {
      // High Volume TIN Flow - Use parallel polling
      response = yield call(getSmartEditOverTimesBulkRequest, restPayload, actionType);
    } else {
      // Normal Flow or Geo Flow
      response = yield call(getSmartEditOverTimesDataRequest, restPayload, actionType, showGeoSegView);
    }

    yield put(fetchSmartEditOverTimesSuccess(response));
    yield put(fetchSmartEditOverTimesLoading(false));
  } catch (error) {
    yield put(fetchSmartEditOverTimesError(true));
    yield put(fetchSmartEditOverTimesLoading(false));
  }
}

export function* getSmartEditTopClaimData(action: any) {
  try {
    yield put(fetchSmartEditTopClaimLoading(true));

    const response = yield call(
      getSmartEditTopClaimDataRequest,
      action?.payload
    );
    yield put(fetchSmartEditTopClaimSuccess(response));
    yield put(fetchSmartEditTopClaimLoading(false));
  } catch (error) {
    yield put(fetchSmartEditTopClaimError(true));
    yield put(fetchSmartEditTopClaimLoading(false));
  }
}

export function* smartEditsSaga() {
  yield takeLatest(
    SMART_EDITS_SUMMARY_REQUEST,
    getSmartEditsSummaryData
  );
  yield takeLatest(
    SMART_EDIT_STATUS_REQUEST,
    getSmartEditStatusData
  );
  yield takeLatest(
    SMART_EDIT_TOP_REASONS_REQUEST,
    getSmartEditTopReasonsData
  );
  yield takeLatest(
    SMART_EDIT_OVER_TIMES_REQUEST,
    getSmartEditOverTimesData
  );
  yield takeLatest(
    SMART_EDIT_TOP_CLAIM_REQUEST,
    getSmartEditTopClaimData
  )
}
